// src/App.js
import "./App.css";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Login from "./components/Auth/Login.js";
import SignUp from "./components/Auth/SignUp.js";
import LandingPage from "./components/LandingPage/LandingPage";
import InnerRoutes from "./components/InnerRoutes/InnerRoutes.js";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute.js";
import Showticker from "./components/Ticker/Showticker.js";
import Navbar from "./components/Navbar/Navbar.js";
import Economic from "./components/Economic/Economic.js";
import Compare from "./components/Compare/Compare.js";
import { useAuthInit } from "./hooks/useAuthInit.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AppRoutes() {
  const { loading } = useAuthInit(); // 🟢 Get loading state

  if (loading) {
    return (
      <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <h2>Loading...</h2> {/* 🌀 Replace with a spinner or branded splash */}
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<><Navbar /><LandingPage /></>} />
      <Route path="/login" element={<><Navbar /><Login /></>} />
      <Route path="/signup" element={<><Navbar /><SignUp /></>} />
      <Route path="/economicdata" element={<><Navbar /><Economic /></>} />
      <Route path="/comparestocks" element={<><Navbar /><Compare /></>} />
      <Route path="/ticker" element={<><Navbar /><Showticker /></>} />
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/" element={<InnerRoutes />} />
        <Route path="/*" element={<InnerRoutes />} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
